"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customer = require("@/api/customer");
var _vuePropertyDecorator = require("vue-property-decorator");
var _depositOrder = require("@/types/depositOrder");
var CustomerOrderForm = /*#__PURE__*/function (_Vue) {
  function CustomerOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "checkCustomerMonthBirthday", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "rules", {
      customerId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "DepositOrderStatus", _depositOrder.DepositOrderStatus);
    (0, _defineProperty2.default)(_this, "customers", []);
    return _this;
  }
  (0, _inherits2.default)(CustomerOrderForm, _Vue);
  return (0, _createClass2.default)(CustomerOrderForm, [{
    key: "disableForm",
    get: function get() {
      return this.orderStatus == _depositOrder.DepositOrderStatus.Complete || this.disabled;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchCustomers();
    }
  }, {
    key: "handleCreateCustomer",
    value: function handleCreateCustomer() {
      this.$refs.customerModal.handleCreate();
    }
  }, {
    key: "handleChangeCustomer",
    value: function () {
      var _handleChangeCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, customer;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _customer.customerApi.findOne(this.form.customerId);
            case 2:
              res = _context.sent;
              customer = res.data.customer;
              if (customer) {
                this.$set(this.form, "detailCustomer", res.data);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleChangeCustomer() {
        return _handleChangeCustomer.apply(this, arguments);
      }
      return handleChangeCustomer;
    }()
  }, {
    key: "fetchCustomers",
    value: function fetchCustomers() {
      var _this2 = this;
      _customer.customerApi.findAll({
        isExistConSign: true
      }).then(function (res) {
        _this2.customers = res.data.customers;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], CustomerOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], CustomerOrderForm.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "checkCustomerMonthBirthday", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "compare", void 0);
CustomerOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerDialog: function CustomerDialog() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/customer/components/CustomerDialog.vue"));
      });
    }
  }
})], CustomerOrderForm);
var _default = exports.default = CustomerOrderForm;